import axios from 'axios'
import { AccountInterface } from 'client/Interfaces/AccountsInterface'

import { ExternalAccountInterface } from '../Interfaces/ExternalAccountInterface'
import { getRequestConfig } from './index'

interface GetExternalAccountsResponse {
  accounts: ExternalAccountInterface[]
}

export const getExternalAccounts = async (): Promise<ExternalAccountInterface[]> => {
  const response = await axios.get<GetExternalAccountsResponse>(
    '/platform/v4/company/external-accounts',
    getRequestConfig(),
  )
  return response.data.accounts
}
